(function () {
    const header = document.querySelector('.header');

    document.addEventListener('scroll', () => {
        document.body.scrollTop > 0 || document.documentElement.scrollTop > 0 ?
            header.classList.add('header_shrink') :
            header.classList.remove('header_shrink')
    }, {
        passive: true
    });
}());

(function () {
    const headerBurger = document.querySelector('.header__burger');
    const headerBurgerAside = document.querySelector('.header__aside-burger');
    const headerAside = document.querySelector('.header__aside');
    const headerAsideWrap = document.querySelector('.header__aside-wrap');

    const asideAction = () =>{
        headerAside.classList.toggle('header__aside_active')
    }

    if (headerBurger && headerBurgerAside) {
        headerBurger.addEventListener('click', () => asideAction());
        headerBurgerAside.addEventListener('click', () => asideAction());

        headerAside.addEventListener('click', (e) => {
            if (!headerAsideWrap.contains(e.target)) asideAction()
        });
    }
}());
